import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { selectToken } from '../../../features/auth/ducks';
import { normalizeString } from '../../../common/utils/helpers';
import { apiCallIds } from '../../account-management/api';
import { CallCentrumScreen } from '../components'
import {
  fetchAccountsActions,
  selectAccounts,
  selectAccountsFilter,
  selectAccountsPagination,
  setAccountsFilterAction,
} from '../../account-management/ducks';

const mapStateToProps = state => ({
  accounts: selectAccounts(state),
  filter: selectAccountsFilter(state),
  token: selectToken(state),
  isLoading: selectIsInProgress(state, apiCallIds.FETCH_ACCOUNTS),
  pagination: selectAccountsPagination(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAccounts: fetchAccountsActions.request,
      setFilter: setAccountsFilterAction,
    },
    dispatch
  ),
});

const defaultFilter = {
  search: '',
};

@connect(mapStateToProps, mapDispatchToProps)
export default class CallCentrumLandingContainer extends Component {
  static propTypes = {
    accounts: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    pagination: PropTypes.object.isRequired,
    token: PropTypes.string.isRequired,
  };

  componentDidMount() {
    const { actions, filter } = this.props;
    actions.setFilter(defaultFilter);

    if(this.props.location.query){
      let searchString = ''
      for (let [key, value] of Object.entries(this.props.location.query)){
        searchString = value
      }
      actions.setFilter({
        ...filter,
        search: normalizeString(searchString),
        registrationStatus: '',
      })
    }
    else {
      actions.fetchAccounts(defaultFilter);
    }

  }

  handleTableChange = (pagination, filters, sorter) => {
    const { actions, filter } = this.props;
    console.log('hereeeeee')
    actions.fetchAccounts({
      ...filter,
      pageNo: pagination.current - 1,
    });
  };

  onFilterSearchChange = filterValue => {
    const { actions, filter } = this.props;
    console.log('hereeeeee filter search')
    actions.setFilter({
      ...filter,
      search: normalizeString(filterValue),
      registrationStatus: '',
    });
  };



  render() {
    const { accounts, filter, isLoading, pagination, token } = this.props;

    return (
      <CallCentrumScreen
        accounts={accounts}
        filter={filter}
        isLoading={isLoading}
        onFilterSearchChange={this.onFilterSearchChange}
        onTableChange={this.handleTableChange}
        pagination={pagination}
        token={token}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/call-centrum/containers/CallCentrumLandingContainer.js